import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyD9JoGhnlsv7FguTUeHNb1JsO-ntGlRbSI",
  authDomain: "clone-c5244.firebaseapp.com",
  projectId: "clone-c5244",
  storageBucket: "clone-c5244.appspot.com",
  messagingSenderId: "686189628538",
  appId: "1:686189628538:web:01b7e58c389af6ba467fc3"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const db = getFirestore(app);

const auth = getAuth(app);

const provider = new GoogleAuthProvider();

export { db, auth, provider };
